import Vue from 'vue';
import App from './App.vue';
import Vant from 'vant';
import 'vant/lib/index.css';
import router from './router';
import http from './http';
import VueAwesomeSwiper from 'vue-awesome-swiper'
import common from './common/function'
import 'swiper/swiper-bundle.css'
import store from './store'
import VueI18n from 'vue-i18n';
import '@vant/touch-emulator';
import { Lazyload } from 'vant';
import 'video.js/dist/video-js.css'
// 金额格式化：20000000 => 20.000.000
export const formatMoney = function formatMoney(value) {
  if (
    value === null ||
    value === undefined ||
    value === ''
  ) {
    return '0'
  }
  const number = Math.floor(
    Number(value)
  )
  if (!Number.isFinite(number)) {
    return '0'
  }
  return number.toLocaleString(
    'es-MX',
    {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }
  )
}
Vue.filter('formatMoney',formatMoney)
Vue.prototype.$http = http
Vue.prototype.common = common
Vue.config.productionTip = false
// =========================================================
// Build Info
// 打包后浏览器 F12 可以查看当前分支和 commit
// =========================================================
window.__BUILD_INFO__ = {
  branch:
    process.env.VUE_APP_BUILD_BRANCH ||
    'unknown',

  name:
    process.env.VUE_APP_BUILD_NAME ||
    '',

  commit:
    process.env.VUE_APP_BUILD_COMMIT ||
    'unknown',

  buildTime:
    process.env.VUE_APP_BUILD_TIME ||
    ''
}
Vue.use(VueAwesomeSwiper)
Vue.use(Vant);
Vue.use(Lazyload)
Vue.use(VueI18n);
const i18n = new VueI18n({
  globalInjection: true,
  locale: localStorage.getItem("viodeLang") || store.state.langDefault, // 将要切换的语言，可以通过url拼的参数获取，用户行为select选择获取，本地manifest配置获取等，根据场景动态获取
  messages: {
    'zh_cn': require('./assets/languages/zh_cn.json'),
    'en_us': require('./assets/languages/en_us.json'),
    'es_spa': require('./assets/languages/es_spa.json'),
    'ms_my': require('./assets/languages/ms_my.json'),
    'vn_vn': require('./assets/languages/vn_vn.json'),
    'ja_ja': require('./assets/languages/ja_ja.json'),
    'fr_fr': require('./assets/languages/fr_fr.json'),
  }
});

new Vue({
  store,
  router,
  i18n,
  render: h => h(App),
}).$mount('#app')